import React, { useEffect } from 'react';


import { useAuth0 } from '@auth0/auth0-react';
import SUBSCRIPTIONS_LOGO from '../../assets/images/subscriptions-logo.svg';
import appInsights from '../../common/applicationInsights';
import EventProcess from "../../common/trackedEventProcessEnum";
import EventTypes from "../../common/trackedEventTypeEnum";
import LoginComponent from '../../components/loginComponent/loginComponent';
const login = () => {
    const { loginWithRedirect } = useAuth0();

    useEffect(() => {
        appInsights.trackEvent("User opened the login screen", EventTypes.OpenedPortal, EventProcess.Default);
    }, []);

    const onLoginClickCallback = () => {
        loginWithRedirect();
    }

    return (
        <LoginComponent onLogin={onLoginClickCallback} logoSrc={SUBSCRIPTIONS_LOGO} />
    );
};

export default login;
